import React from "react";
import ReactDOM from "react-dom";
import "./i18nextConf";
import "./index.css";
import { InitializationPage } from "./InitializationPage";

ReactDOM.render(
  <React.StrictMode>
    <InitializationPage />
  </React.StrictMode>,
  document.getElementById("root")
);
